import React from 'react';
import styled from '@emotion/styled';
import { OnSaleCourseDetails } from '@yi/core/src/course-sale';

import { useCourseSale } from '~/src/common/courses';
import { useUserWithPurchasedCoursesByIds } from '~/src/common/user/useUserWithPurchasedCoursesByIds';
import { fontWeight } from '~/src/styles';

const Container = styled.div`
  z-index: 5;
  position: relative;
  overflow: hidden;
  width: 75px;
  height: 80px;
  position: absolute;
  right: 0;
`;
const Ribbon = styled.div`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 1px 0px;
  background: var(--Primary);
  font-size: 15px;
  line-height: 18px;
  font-weight: ${fontWeight.bold};
  letter-spacing: 0em;
  text-align: center;
  color: white;
  width: 100px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  transform: rotate(45deg);
  top: 8px;
  position: absolute;
`;

interface Props {
  courseDetails: OnSaleCourseDetails;
}

function useIsCoursePurchased(courseDetails: OnSaleCourseDetails) {
  const { loading, currentUser } = useUserWithPurchasedCoursesByIds([courseDetails.id]);

  const isPurchased = (currentUser?.purchased_courses ?? []).find(
    item => item.course.id === courseDetails.id,
  );

  return { loading, isPurchased };
}

export const OnSaleRibbon: React.FC<Props> = ({ courseDetails }) => {
  const courseSale = useCourseSale(courseDetails);
  const { isPurchased, loading } = useIsCoursePurchased(courseDetails);

  if (loading || isPurchased || !courseSale.isOnSale()) {
    return null;
  }

  const discountPercentage = courseSale.saleOffer()?.value?.amount ?? null;

  if (discountPercentage === null) {
    return null;
  }

  return (
    <Container>
      <Ribbon>- {discountPercentage}%</Ribbon>
    </Container>
  );
};
